import { createRouter, createWebHistory } from 'vue-router'
import { checkGeolocationPermissions } from '@/plugins/geolocation'
import { checkUrlRedirection } from '@/plugins/redirection'
import { onMounted } from 'vue'
import { registrarVistas } from '@/plugins/estadisticas'

import Home from '@/views/Home.vue'
import CommercialView from '@/views/CommercialView.vue'
import CatalogueView from '@/views/CatalogueView.vue'
import LocationView from '@/views/LocationView.vue'
import GeolocationView from '@/views/GeolocationView.vue'
import CafeView from '@/views/CafeView.vue'
import ExperienceTypesView from '@/views/ExperienceTypesView.vue'
import ExperiencesByTypeView from '@/views/ExperiencesByTypeView.vue'
import ExperienceView from '@/views/ExperienceView.vue'
import BookingView from '@/views/BookingView.vue'
import PersonalDataView from '@/views/PersonalDataView.vue'
import TurnView from '@/views/TurnView.vue'
import CinemaView from '@/views/CinemaView.vue'
import LegalNoticesView from '@/views/LegalNoticesView.vue'
import FaqsView from '@/views/FaqsView.vue'

// Solo maqueta: panel de atajos de desarrollo (ver DevToolsView.vue)
const DEV_TOOLS = process.env.VUE_APP_DEV_TOOLS === 'true'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/commercial',
    name: 'Commercial',
    component: CommercialView,
//    beforeEnter: checkGeolocationPermissions,
    props: (route) => ({ procedure: route.query.procedure || 'visible' })
  },
  {
    path: '/catalogue',
    name: 'Catalogue',
    component: CatalogueView
  },
  {
    path: '/location',
    name: 'Location',
    component: LocationView,
  //  beforeEnter: checkGeolocationPermissions
  },
  {
    path: '/geolocation',
    name: 'Geolocation',
    component: GeolocationView
  },
  {
    path: '/cafe',
    name: 'Cafe',
    component: CafeView
  },
  {
    path: '/agenda',
    name: 'ExperienceTypes',
    component: ExperienceTypesView
  },
  {
    path: '/experiences/:experienceTypeCode',
    name: 'ExperiencesByType',
    component: ExperiencesByTypeView,
    props: true
  },
  {
    path: '/experience/:experienceCode',
    name: 'Experience',
    component: ExperienceView,
    props: true
  },
  {
    path: '/personalData/:audience',
    name: 'PersonalData',
    component: PersonalDataView,
    props: true
  },
  {
    path: '/booking/:audience',
    name: 'Booking',
    component: BookingView,
    props: true
  },
  {
    path: '/turn',
    name: 'Turn',
    component: TurnView
  },
  {
    path: '/cinema',
    name: 'Cinema',
    component: CinemaView
  },
  {
    path: '/legalNotices',
    name: 'LegalNotices',
    component: LegalNoticesView
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: FaqsView
  }
]

// La ruta /dev solo existe si VUE_APP_DEV_TOOLS === 'true'.
// Sin esa variable el import ni siquiera se evalua y la ruta no se registra.
if (DEV_TOOLS) {
  routes.push({
    path: '/dev',
    name: 'DevTools',
    component: () => import('@/views/DevToolsView.vue')
  })
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ left: 0, top: 0 })
      }, 10)
    })
  }
})

registrarVistas(router)

export default router
